import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

class AXEventService {
    constructor() {
        this.eventSubject = new Subject();
        // Observable property
        this.onEvent = this.eventSubject.asObservable();
        this.list = [];
    }
    emitEvent(event) {
        this.eventSubject.next(event);
    }
    broadcast(key, options) {
        const d = this.list.find((c) => c.key === key);
        if (d) {
            d.events.forEach((c) => {
                c(options);
            });
        }
    }
    on(key, callback) {
        let d = this.list.find((c) => c.key === key);
        if (!d) {
            d = { key, events: [] };
            this.list.push(d);
        }
        d.events.push(callback);
    }
    destroy(key, callback) {
        const d = this.list.find((c) => c.key === key);
        if (d) {
            d.events = [];
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXEventService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXEventService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXEventService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

const AXEventTypes = {
    AXLanguageChanged: 'AX_LANGUAGE_CHANGED',
    AXLanguageLoaded: 'AX_LANGUAGE_LOADED',
    AXCalendarChanged: 'AX_CALENDAR_CHANGED',
};

/**
 * Generated bundle index. Do not edit.
 */

export { AXEventService, AXEventTypes };
